import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useMergedRef } from "../../hooks/useMergedRef.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { useKeyboardNavigation } from "../../hooks/useKeyboardNavigation.mjs.mjs";
import { StyledRoot, StyledSegment } from "./Indicator.styles.mjs.mjs";
const MAX_INDICATOR_SEGMENTS = 7;
export const IndicatorItemInternalsContext = React.createContext({
    isSelected: false,
    keyboardNavigationRef: () => undefined,
});
export const Indicator = React.forwardRef(function Indicator({ selectedIndex, onSelect, children, ...restProps }, forwardRef) {
    const rootProps = {
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    const sanitizedItems = React.Children.toArray(children).slice(0, MAX_INDICATOR_SEGMENTS);
    const { handleKeyboardNavigation, includeInKeyboardNavigation } = useKeyboardNavigation({
        cycle: true,
    });
    return (React.createElement(StyledRoot, { ...rootProps, ref: forwardRef, onKeyDown: handleKeyboardNavigation, role: "tablist" }, sanitizedItems.map((item, index) => {
        const handleClick = onSelect
            ? (event) => {
                index !== selectedIndex && onSelect(index, event);
            }
            : undefined;
        return (React.createElement("li", { key: `li-${item.key}`, role: "presentation" },
            React.createElement(IndicatorItemInternalsContext.Provider, { value: {
                    keyboardNavigationRef: includeInKeyboardNavigation,
                    isSelected: index === selectedIndex,
                    onClick: handleClick,
                } }, item)));
    })));
});
export const IndicatorItem = React.forwardRef(function IndicatorItem({ ...restProps }, forwardRef) {
    const rootProps = {
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    const internals = React.useContext(IndicatorItemInternalsContext);
    const mergedRef = useMergedRef(forwardRef, internals.keyboardNavigationRef);
    return (React.createElement(StyledSegment, { ...rootProps, ref: mergedRef, role: "tab", "aria-selected": internals.isSelected, tabIndex: internals.isSelected ? undefined : -1, onClick: internals.onClick }));
});
//# sourceMappingURL=Indicator.mjs.mjs.map